import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import { Customer, useCheckBuyEligibilityMutation } from 'gen/rtk-openapi'

const useDoNotBuyCheck = () => {
  const { details } = useAppSelector(state => state.settings)
  const [checkBuyEligibility, { isLoading: isCheckingBuyEligibility }] = useCheckBuyEligibilityMutation()

  /**
   * Check if the customer has a do not buy violation
   * If any contact has a do not buy violation, return true
   * @param custContactArray
   */
  const checkDoNotBuyViolation = async (custContactArray: Customer['contacts']): Promise<boolean> => {
    if (details?.state !== 'OH' || !custContactArray?.length) return false

    const result = await checkBuyEligibility({
      body: custContactArray || [],
    })

    if ('data' in result && Array.isArray(result?.data)) {
      const doNotBuyContacts = result.data?.filter(contact => !!contact.doNotBuy) || []
      if (doNotBuyContacts.length > 0) return true
    }

    return false
  }

  return { checkDoNotBuyViolation, isCheckingBuyEligibility }
}

export default useDoNotBuyCheck
